export enum SettingType {
  text = 0,
  password = 1,
  number = 2,
  boolean = 3,
  option = 4,
  apiKey = 5
}